export const APP_CONFIG = {
  appName: 'Schaeffler Benefits',
  frontend: 'https://schaefflerbenefits.com',
  apiHash: 'https://schaefflerbenefits.com/api/1.0',
  api: '/api/2.0',
  trustModel: false,
  commitSHA: '1664030',
  authHeaders: {
    xServiceProvider: 'schaeffler-prod-frontend',
    'tenant-id': '9298c9f2-937b-458c-8034-328f109c2c02',
    'consumer-id': 'c478503b-f77d-4c9f-81db-7b73ce510dad',
  },
  provider: 'schaeffler-prod-frontend',
  multilingual: true,
  demoMode: false,
  isDarkModeEnabled: false,
  benefitCategories: true,
  contactEnabled: false,
  countrySelectEnabled: true,
  notificationsEnabled: false,
  showPosts: false,
  cookiePolicy: 'a57e434e',
  colors: {
    primary: '#00893D',
    secondary: '#F3F9FA',
    actionBg: '#00893D',
    actionText: '#FFF',
    headingText: '#1D9BB2',
    subheadingText: '#134A54',
    linkColor: '#00893D',
  },
  imagery: {
    logo: 'https://storage.googleapis.com/archipelago-assets/schaeffler/schaeffler-logo.svg',
    logoInverted: 'https://storage.googleapis.com/archipelago-assets/schaeffler/schaeffler-logo.svg',
    logoTransparent: 'https://storage.googleapis.com/archipelago-assets/schaeffler/schaeffler-logo.svg',
    favicon: 'https://storage.googleapis.com/archipelago-assets/schaeffler/favicon.ico',
  },
  navigation: {
    navType: 'top',
    collapsibleSidenav: false,
    headerStyle: 'solid',
    categoryNav: true,
    navigationOrder: 'displayOrder',
    navbarBrandWidth:'232px',
    includeBottomBorder: true,
    includeBoxShadow: false,
  },
  gtm: '',
  enableLeaveOfAbsenceTool:true,
  customContactButton: {
    enabled: true,
    target: true,
    path: 'https://gcly.io/C9cWzuW86',
    text: 'Join Us Today',
  },
  buttonStyle: 'pill',
  typography: {
    font: {
      heading: {
        family: 'ff-meta-web-pro',
        url: 'https://use.typekit.net/rfu4rbj.css',
      },
      body: {
        family: 'Inter',
        url: 'https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap',
      },
      accent: {
        family: 'ff-meta-web-pro',
        url: 'https://use.typekit.net/rfu4rbj.css',
      },
    },
  },
  footerDivider: '#1D9BB2',
  copyright: '© ' + new Date().getFullYear() +
    ' Gallagher | All Rights Reserved.' + ' Powered by Core.'
};
